import React from "react";
import {styled} from "@mui/material";

const StyledImg = styled('img') ({
    paddingTop: '10px',
    border: '1px solid rgba(60,120,185,1)',
    borderRadius: '8px'
})

export default function NpiPageInstruction () {
    const NPILink = "https://download.cms.gov/nppes/NPI_Files.html";

    return (
        <div>
            <strong>Step 1</strong>
            <p>Go to this {<a href={NPILink} target="_blank">link</a>}</p>
            <StyledImg src={require('../images/NPI Files Download Page.png')?.default}/>
            <br/>
            <strong>Step 2</strong>
            <ol>
                <li>Right click on the NPI Files you want</li>
                <li>Select the option - <strong>Copy Link Address</strong></li>
                <li>Back to the <strong>New Npi Import Task</strong> page and click on the button <i>FULL OR INCREMENTAL</i></li>
                <li>Select one of the options and paste the link into the text box</li>
            </ol>
            <StyledImg src={require('../images/NPI Files Copy Link.png')?.default}/>
        </div>
    )
}